import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/components/ContactClient.tsx");
